module.exports = __webpack_public_path__ + "img/image_icon.e1fbfcfc.svg";